import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id C34618B6-174E-42C7-AD23-B65FCAC93D74
 * name alpha-i
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-i.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaIIcon = createSvgIcon(<><path d="M14,7V9H13V15H14V17H10V15H11V9H10V7H14Z" /></>, 'AlphaIIcon');
export default AlphaIIcon